import React from 'react'
import { Link } from 'react-router-dom'
import { FaInstagram, FaTiktok, FaYoutube, FaSoundcloud, FaSpotify, FaHeart } from 'react-icons/fa'
import useTranslation from '../hooks/useTranslation'

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          {/* Social Links */}
          <div className="footer-section">
            <h3>{t('footer.followMe')}</h3>
            <div className="social-links">
              <a href="https://instagram.com/ayite__" target="_blank" rel="noopener noreferrer">
                <FaInstagram /> @ayite__
              </a>
              <a href="https://www.tiktok.com/@ayite.music" target="_blank" rel="noopener noreferrer">
                <FaTiktok /> @ayite.music
              </a>
              <a href="https://www.youtube.com/@AYITE_ofc/shorts" target="_blank" rel="noopener noreferrer">
                <FaYoutube /> @AYITE_ofc
              </a>
              <a href="https://soundcloud.com/ayite1210" target="_blank" rel="noopener noreferrer">
                <FaSoundcloud /> SoundCloud
              </a>
              <a href="https://open.spotify.com/artist/0EnoBn9WE5d6NNay8cm8Wi?si=3a9m2usWSuCeMaldqRYg2g" target="_blank" rel="noopener noreferrer">
                <FaSpotify /> Spotify
              </a>
            </div>
          </div>

          {/* Legal Links */}
          <div className="footer-section">
            <h3>AYITE</h3>
            <div className="legal-links">
              <a href="https://epk.ayite.de/" target="_blank" rel="noopener noreferrer">{t('footer.pressKit')}</a>
              <Link to="/impressum">{t('footer.impressum')}</Link>
              <Link to="/privacy">{t('footer.privacy')}</Link>
            </div>
          </div>
        </div>

        {/* Copyright and Credits */}
        <div className="footer-bottom">
          <p>{t('footer.copyright')}</p>
          <p className="created-by">
            Made with <FaHeart style={{ color: '#ff4d4d', fontSize: '0.8em', verticalAlign: 'middle' }} /> in Nuremberg by <a href="https://eltai-consulting.com" target="_blank" rel="noopener noreferrer">Eltai Consulting</a>
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
